import { Box } from "@mui/material";

export const FullPaddingWrapper = ({ children }: any): any => {
  return (
    <Box
      sx={{
        p: {
          xl: "20px 50px 0px 50px",
          lg: "20px 50px 0px 50px",
          md: "12px 12px 0px 12px",
          sm: "16px 16px 16px 16px",
          xs: "16px 4px 8px 4px",
        },
        // backgroundColor: "rebeccapurple",
      }}
    >
      {children}
    </Box>
  );
};
